function cssEscape(value: string): string {
  return typeof CSS !== "undefined" && CSS.escape
    ? CSS.escape(value)
    : value.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
}

function isUnique(selector: string): boolean {
  try {
    return document.querySelectorAll(selector).length === 1;
  } catch {
    return false;
  }
}

function segmentFor(el: Element): string {
  const tag = el.tagName.toLowerCase();
  const stableClasses = Array.from(el.classList)
    .filter((c) => !c.startsWith("bw-") && c.length < 40 && !/[[\]:]/.test(c))
    .slice(0, 2);
  let seg = tag + stableClasses.map((c) => "." + cssEscape(c)).join("");
  const parent = el.parentElement;
  if (parent) {
    const siblings = Array.from(parent.children).filter((s) => s.tagName === el.tagName);
    if (siblings.length > 1) {
      seg += `:nth-of-type(${siblings.indexOf(el) + 1})`;
    }
  }
  return seg;
}

/**
 * Construit un sélecteur CSS unique pour l'élément : id si possible, sinon
 * un chemin de segments tag/classes/nth-of-type, raccourci dès qu'il devient
 * unique dans le document.
 */
export function buildSelector(el: Element): string {
  if (el.id && isUnique("#" + cssEscape(el.id))) return "#" + cssEscape(el.id);

  const path: string[] = [];
  let current: Element | null = el;
  while (current && current !== document.documentElement) {
    if (current.id && isUnique("#" + cssEscape(current.id))) {
      path.unshift("#" + cssEscape(current.id));
      break;
    }
    path.unshift(segmentFor(current));
    const candidate = path.join(" > ");
    if (isUnique(candidate)) return candidate;
    current = current.parentElement;
  }
  return path.join(" > ") || el.tagName.toLowerCase();
}
